// src/helpers/withNavigation.js
import * as React from 'react';
import { useNavigate } from "react-router-dom";

export function withNavigation(Component) {
    const WrappedComponent = (props) => {
        const navigate = useNavigate();
        return <Component {...props} navigate={navigate} />;
    };

    WrappedComponent.displayName = `withNavigation(${Component.displayName || Component.name || "Component"})`;

    return WrappedComponent;
}